module.exports = __webpack_public_path__ + "src/img/zalando/tabbar copy.ef138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/tabbar copy.jpg
// module id = 272
// module chunks = 0